<template>
  <div
    class="skeleton-editor w-100"
  >
    <div
      class="bg-bgDefault w-100 px-9 py-8"
    >
      <v-skeleton-loader
        type="heading"
        width="314px"
        :class="{ show: animationIndex > 1, hide: animationIndex <= 1 }"
      />
      <v-skeleton-loader
        type="heading"
        width="195px"
        class="mt-2 skeleton-sub-heading"
        :class="{ show: animationIndex > 1, hide: animationIndex <= 1 }"
      />
    </div>
    <div :class="'skeleton-editor-content mt-7 bg-bgDefault w-100 px-9 py-8'">
      <div
        class="pb-9"
      >
        <v-skeleton-loader
          type="heading"
          width="314px"
          :class="{ show: animationIndex > 1, hide: animationIndex <= 1 }"
        />
        <v-skeleton-loader
          type="heading"
          width="195px"
          class="mt-2 skeleton-sub-heading"
          :class="{ show: animationIndex > 1, hide: animationIndex <= 1 }"
        />
      </div>
      <v-skeleton-loader
        type="paragraph"
        width="100%"
        :class="{ show: animationIndex > 2, hide: animationIndex <= 2 }"
      />
      <v-skeleton-loader
        type="text"
        class="mb-8"
        width="385px"
        :class="{ show: animationIndex > 2, hide: animationIndex <= 2 }"
      />
      <v-skeleton-loader
        type="text"
        class="mb-7"
        width="195px"
        :class="{ show: animationIndex > 2, hide: animationIndex <= 2 }"
      />
      <v-skeleton-loader
        type="paragraph"
        width="100%"
        :class="{ show: animationIndex > 2, hide: animationIndex <= 2 }"
      />
      <v-skeleton-loader
        type="text"
        class="mb-8"
        width="385px"
        :class="{ show: animationIndex > 2, hide: animationIndex <= 2 }"
      />
      <v-skeleton-loader
        type="paragraph"
        width="100%"
        :class="{ show: animationIndex > 3, hide: animationIndex <= 3 }"
      />
      <v-skeleton-loader
        type="text"
        class="mb-8"
        width="385px"
        :class="{ show: animationIndex > 3, hide: animationIndex <= 3 }"
      />
      <v-skeleton-loader
        type="text"
        class="mb-7"
        width="195px"
        :class="{ show: animationIndex > 3, hide: animationIndex <= 3 }"
      />
      <div
        v-if="!isSideBySideView"
        class="floating-action-skeleton bg-bgDefault"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditorSkeleton',
  props: {
    animationIndex: { type: Number, default: 0 },
    isSideBySideView: { type: Boolean, default: false },
  },
};
</script>

<style lang="less" scoped>
.skeleton-editor {
  border: 0;
  min-height: calc(100vh - 250px);
  user-select: none;
  padding-top: 0;
  padding-bottom: 12px;
}

.skeleton-editor-content {
  position: relative;
}

.floating-action-skeleton {
  width: 21px;
  height: 21px;
  border-radius: 50%;
  position: absolute;
  bottom: -10.5px;
  left: calc(50% - 10.5px);
}

.field-label {
  position: absolute;
  top: -20px;
  right: 28px;
}

.field-label :deep(.text) {
  width: 61px;
}

.hide {
  opacity: 0;
}

.show {
  animation: fadeIn .25s;
}

@keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}
</style>
